import { ReviewsAPI } from "@/api/reviews";
import { TasksCacheService } from "../tasks/cache";
import { SchedulerCacheService } from "../scheduler/cache";

export const ReviewsService = {
  async createReview(data) {
    const { data: review } = await ReviewsAPI.createReview(data);
    TasksCacheService.invalidateAll();
    SchedulerCacheService.invalidateAll();
    return review;
  },
  async updateReview(id, updates) {
    const { data: review } = await ReviewsAPI.upateById(id, updates);
    TasksCacheService.invalidateAll();
    SchedulerCacheService.invalidateAll();
    return review;
  },
};
